import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcVideoShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import VideosActions from 'app/actions/VideosActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectVideosTransactions } from 'app/selectors/ugc/VideosSelector';
import { selectOpenUgcEditors } from 'app/selectors/ui/UgcEditorSelector';
import VideoEditor from './VideoEditor';

export function VideoEditorContainer(props) {
  return <VideoEditor {...props} />;
}

VideoEditorContainer.propTypes = {
  // ownProps
  existingVideo: ugcVideoShape,
  metadataId: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func,
  handleCancel: PropTypes.func,

  // Props from Redux store
  open: PropTypes.bool.isRequired,
  currentUser: userIdentityShape,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  currentUser: selectCurrentUser(state),
  videosTransactions: selectVideosTransactions(state),
  open: !!ownProps.existingVideo || selectOpenUgcEditors(state).has('video')
});

const mapDispatchToProps = dispatch => ({
  videosActions: bindActionCreators(VideosActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoEditorContainer);
